import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from 'store';
import xamatron from "xamatron";
var PrivacySettingsView = /** @class */ (function (_super) {
    tslib_1.__extends(PrivacySettingsView, _super);
    function PrivacySettingsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.sulEmail = "kunniakierros@sul.fi";
        return _this;
    }
    Object.defineProperty(PrivacySettingsView.prototype, "privacyPolicyUrl", {
        get: function () { return this.root.getSiteUrl("public/privacypolicy"); },
        enumerable: true,
        configurable: true
    });
    PrivacySettingsView.prototype.routed = function () {
        store.page.title = this.$t("privacySettingsView.title");
    };
    PrivacySettingsView.prototype.openPrivacyPolicy = function () {
        xamatron.openURL(this.privacyPolicyUrl);
    };
    PrivacySettingsView = tslib_1.__decorate([
        Component
    ], PrivacySettingsView);
    return PrivacySettingsView;
}(Vue));
export default PrivacySettingsView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/PrivacySettingsView.vue
// module id = 69
// module chunks = 0